export const stages = [
    {
        Id: '1',
        Name: 'MY FINANCIAL NEED',
        Description__c: `The GO Foundation understands that often it is difficult to afford everything you need for school. The questions in this section help us understand your particular circumstances and why you might need a GO scholarship. Please be as open as you can. We won't share the answers with anyone (and won't tell your school or family) but they will help us better understand how valuable the scholarship will be to you. We need to know about your family circumstances and any money issues you might be facing.`,
    },
    {
        Id: '2',
        Name: 'MY documents',
        Description__c: `The GO Foundation understands that often it is difficult to afford everything you need for school. The questions in this section help us understand your particular circumstances and why you might need a GO scholarship. Please be as open as you can. We won't share the answers with anyone (and won't tell your school or family) but they will help us better understand how valuable the scholarship will be to you. We need to know about your family circumstances and any money issues you might be facing.`,
        Category__c: 'Document',
    },
];

export const questionsWithAnswer = [
    {
        Id: '1',
        Name: `Why have you had to go without things at school or in life? `,
        Helper_Text__c: `GO Scholarships are awarded to students who have a financial need. This question is not asking WHAT you've gone without. It is asking WHY you've gone without. For example, Nan might rely on Centrelink to support you, you might be in out of home care or your parents might not have a job. `,
        Min_words__c: 300,
        Max_words__c: 600,
        Type__c: 1,
        'Required__c': true,
        'Answer__c.Answer__c': 'sdfskldfsdflfdskfjsdf'
    },
    {
        Id: '2',
        Name: `What have you missed out on or gone without at school? *`,
        Options__c: `Textbooks|Excursions|Uniform items|School shoes|Other`,
        Type__c: 2,
        'Required__c': true,
        'Answer__c.Answer__c': `Textbooks|Excursions|Other`,
    },
    {
        Id: '3',
        Name: `Do you have a part-time job? *`,
        Helper_Text__c: `Please let us know why you work part-time. For example, Do you help mum pay the rent, do you use the money for school stuff or do you save it for when you might need something?`,
        Options__c: `Yes|No`,
        extras: `How many hours a week do you work? *|What do you use the money for? *`,
        Type__c: 3,
        'Required__c': true,
        'Answer__c.Answer__c': 'Yes',
    },
    {
        Id: '4',
        Name: `How many hours a week do you work? *`,
        'Required__c': true,
        'Answer__c.Answer__c': 'aaa',
        Parent_Question__c: '3',
        Extra_Option__c: `Yes`
    },
    {
        Id: '5',
        Name: `What do you use the money for? *`,
        'Required__c': true,
        'Answer__c.Answer__c': 'bbb',
        Parent_Question__c: '3',
        Extra_Option__c: `Yes`
    },
    {
        Id: '6',
        Name: `Please enter any other things you missed out on or went without at school`,
        'Required__c': true,
        'Answer__c.Answer__c': 'ccc',
        Parent_Question__c: '2',
        Extra_Option__c: `Other`
    },
    {
        Id: '7',
        Name: `Please upload your School Report`,
        'Required__c': true,
        'Answer__c.Answer__c': '',
        Type__c: 4,
        Helper_Text__c: `We need to see your most recent School Report. If you are submitting this application in Term 1 or 2, it will be your most recent Term 4 report. If you are submitting this application in Term 3 or 4, it will be your Term 2 report. 
        <br /><br />Please upload every page of your report. If you don’t, your application will be considered incomplete.`
    },
    {
        Id: '8',
        Name: `Please upload your NAPLAN results`,
        'Required__c': true,
        'Answer__c.Answer__c': '',
        Type__c: 4,
        Helper_Text__c: `We need a copy of your most recent NAPLAN result. So, if you are in Year 8, it will be your Year 7 NAPLAN. If you are in Year 10, it will be your Year 9 NAPLAN.
        <br /><br />Please upload ALL inside pages of your NAPLAN results. You should upload two pages.`
    },
]
